import { makeStyles } from '@material-ui/core';
import CreateSvg from 'assets/images/create.svg';
import React, { ReactElement } from 'react';

const useStyles = makeStyles(() => ({
  logo: {
    width: '20px',
    height: '20px',
    objectFit: 'cover',
  },
}));

function Create(): ReactElement {
  const classes: any = useStyles();
  return <img src={CreateSvg} alt="Create icon" className={classes.logo} />;
}

export default Create;
